import 'flag-icons/css/flag-icons.min.css';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Sidebar } from 'primereact/sidebar';
import { useEffect, useState } from 'react';
import Tag from '../../../../components/Display/Tag';
import FormInput from '../../../../components/Form/FormInput';
import RichTextEditor from '../../../../components/Form/RichTextEditor';
import { CONSTANT } from '../../../../utils/constants';
import { validateURL } from '../../../../utils/stringHelper';
import ImageForm from '../../common/image/ImageForm';

function ProgramPanel({ isOpen, onClose, onCreate, program, onUpdate, loading }) {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [deezerId, setDeezerId] = useState('');
  const [videoUrl, setVideoUrl] = useState('');

  const [status, setStatus] = useState(undefined); // draft, published

  const [mainImage, setMainImage] = useState(undefined);
  const [secondaryImage, setSecondaryImage] = useState(undefined);

  useEffect(() => {
    if (program) {
      setTitle(program.title);
      setStatus(program.status);
      setDeezerId(program.deezer_id);
      setVideoUrl(program.video_url);
      setDescription(program.description);
      setMainImage(program.main_image);
      setSecondaryImage(program.secondary_image);
    } else {
      setTitle('');
      setStatus(undefined);
      setDeezerId('');
      setVideoUrl('');
      setDescription('');
      setMainImage(undefined);
      setSecondaryImage(undefined);
    }
  }, [program, isOpen]);

  const handleValidate = () => {
    const programPayload = {
      title,
      status,
      deezer_id: deezerId,
      video_url: videoUrl,
      description,
      main_image: mainImage?.id,
      secondary_image: secondaryImage?.id
    };
    program ? onUpdate(programPayload) : onCreate(programPayload);
  };

  const formIsValid = () => {
    return title.length > 3 && description?.length > 3 && validateURL(videoUrl);
  };

  const dropdownTemplate = (option, props) => {
    if (option) {
      return (
        <Tag
          tag={{
            label: option.label,
            bgColor: option.bgColor
          }}
          rounded
        />
      );
    }
    return <span>{props.placeholder}</span>;
  };

  const footerButtons = (
    <div className="manage-footer">
      <Button
        key={'validate'}
        label={`Valider la ${program ? 'modification' : 'création'}`}
        className="w-full"
        onClick={handleValidate}
        severity="success"
        disabled={!formIsValid()}
        loading={loading}
      />
    </div>
  );

  return (
    <Sidebar
      style={{ width: 600 }}
      visible={isOpen}
      position="right"
      onHide={() => onClose(false)}
      header={<h3>{`${program ? 'Modifier' : 'Ajouter'} un programme`}</h3>}>
      <div className="sidebar-content-container">
        <div className="form-wrapper !pb-60">
          <FormInput key="title" label={'Titre du programme'} required isValid={title.length > 3}>
            <InputText
              id="title"
              value={title}
              maxLength={300}
              placeholder="Veuillez saisir le titre du programme"
              onChange={(e) => setTitle(e.target.value)}
            />
          </FormInput>

          {program && (
            <FormInput key="status" label={'État du programme'}>
              <Dropdown
                id="status"
                value={status}
                onChange={(e) => setStatus(e.value)}
                options={CONSTANT.banquetceleste.common.statusTypes}
                optionLabel="label"
                placeholder="Veuillez sélectionner l'état de programme"
                valueTemplate={dropdownTemplate}
                itemTemplate={dropdownTemplate}
              />
            </FormInput>
          )}

          <FormInput key="deezer" label={'ID Deezer'}>
            <InputText
              id="deezerId"
              value={deezerId}
              maxLength={100}
              placeholder="Veuillez saisir l'id unique Deezer"
              onChange={(e) => setDeezerId(e.target.value)}
            />
          </FormInput>

          <FormInput
            label={'URL de la vidéo'}
            errorMessage={!validateURL(videoUrl) && "L'URL doit commencer par http:// ou https://"}>
            <InputText
              id="videoUrl"
              value={videoUrl}
              placeholder="Veuillez saisir l'url de la vidéo"
              onChange={(e) => setVideoUrl(e.target.value)}
              invalid={!validateURL(videoUrl)}
            />
          </FormInput>

          <FormInput
            key="description"
            label={'Description'}
            helpMessage={'Utiliser ctrl+maj+v pour coller le texte sans formattage'}
            required
            isValid={description?.length > 3}>
            <RichTextEditor
              value={description}
              onChange={(value) => {
                setDescription(value);
              }}
            />
          </FormInput>

          <ImageForm
            image={mainImage}
            setImage={setMainImage}
            ratio={1.71}
            deleteImage={() => setMainImage(undefined)}
          />
          <ImageForm
            image={secondaryImage}
            setImage={setSecondaryImage}
            label={'Image secondaire (max. 10Mo)'}
            ratio={1.71}
            deleteImage={() => setSecondaryImage(undefined)}
          />
        </div>
        {footerButtons}
      </div>
    </Sidebar>
  );
}

export default ProgramPanel;
